<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.65 1.94367C10.721 1.53559 11.1094 1.26233 11.5175 1.33334C15.1627 1.9676 18.0324 4.83737 18.6667 8.48256C18.7377 8.89064 18.4645 9.27902 18.0564 9.35002C17.6483 9.42103 17.2599 9.14778 17.1889 8.73969C16.6632 5.71821 14.2818 3.33687 11.2603 2.81113C10.8523 2.74013 10.579 2.35175 10.65 1.94367Z"
            fill="currentColor"
        />
        <path
            d="M18.0564 10.65C18.4645 10.721 18.7377 11.1094 18.6667 11.5175C18.0324 15.1626 15.1627 18.0324 11.5175 18.6667C11.1094 18.7377 10.721 18.4644 10.65 18.0563C10.579 17.6483 10.8523 17.2599 11.2603 17.1889C14.2818 16.6631 16.6632 14.2818 17.1889 11.2603C17.2599 10.8522 17.6483 10.579 18.0564 10.65Z"
            fill="currentColor"
        />
        <path
            d="M2.8111 11.2603C2.7401 10.8522 2.35172 10.579 1.94364 10.65C1.53556 10.721 1.2623 11.1094 1.33331 11.5175C1.96757 15.1626 4.83734 18.0324 8.48253 18.6667C8.89061 18.7377 9.27899 18.4644 9.34999 18.0563C9.421 17.6483 9.14775 17.2599 8.73966 17.1889C5.71818 16.6631 3.33684 14.2818 2.8111 11.2603Z"
            fill="currentColor"
        />
        <path
            d="M9.34999 1.94367C9.421 2.35175 9.14775 2.74013 8.73966 2.81113C5.71818 3.33687 3.33684 5.71821 2.8111 8.73969C2.7401 9.14778 2.35172 9.42103 1.94364 9.35002C1.53556 9.27902 1.2623 8.89064 1.33331 8.48256C1.96757 4.83737 4.83734 1.9676 8.48253 1.33334C8.89061 1.26233 9.27899 1.53559 9.34999 1.94367Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 6.75C8.20508 6.75 6.75 8.20508 6.75 10C6.75 11.7949 8.20508 13.25 10 13.25C11.7949 13.25 13.25 11.7949 13.25 10C13.25 8.20508 11.7949 6.75 10 6.75ZM8.25 10C8.25 9.0335 9.0335 8.25 10 8.25C10.9665 8.25 11.75 9.0335 11.75 10C11.75 10.9665 10.9665 11.75 10 11.75C9.0335 11.75 8.25 10.9665 8.25 10Z"
            fill="currentColor"
        />
    </svg>
</template>
